import { Button, Card, Container, Typography } from "@mui/material";
import { CheckCircle as CheckCircleIcon, Home as HomeIcon } from "@mui/icons-material";

const PaymentSuccess = () => {
	return (
		<Container maxWidth="lg" sx={{ py: 8 }}>
			<Card sx={{ p: 4, textAlign: "center", maxWidth: 600, mx: "auto" }}>
				<CheckCircleIcon sx={{ fontSize: 60, color: "#10B981", mb: 2 }} />
				<Typography variant="h5" gutterBottom>
					Pagamento Realizado com Sucesso!
				</Typography>
				<Typography variant="body1" color="text.secondary" paragraph>
					Seu pagamento foi processado e confirmado.
				</Typography>
				<Button variant="contained" color="primary" size="large" startIcon={<HomeIcon />} sx={{ mt: 2 }} href="/">
					Voltar para o site
				</Button>
			</Card>
		</Container>
	);
};

export default PaymentSuccess;
